import { takeEvery, put, fork, call, all } from 'redux-saga/effects';
import { findReceiptApi, getOtpCodeApi, validateOtpApi, generateRcptReportApi } from "../redux/receiptAPI";
import { callTypes as receiptReducerCallTypes, actions as receiptReducerActions } from "../redux/receiptSlice";
import * as uis from "../../UI/redux/uiSlice";

import { toast } from "react-toastify";
import logman from '../../../../utilities/logman';

export function* onFindReceiptStartAsync({payload}){

    try{
        
        yield put(receiptReducerActions.startCall({ callType: receiptReducerCallTypes.searchingRcpt }));

        const response = yield call(findReceiptApi, payload.receiptNumber);        

        if(response.status === 200){
            let receipt = response.data.receipt;
            let pdfString = response.data.base64ReceiptDoc;
            yield put(receiptReducerActions.receiptFound({receipt, pdfString}));
        }
    }
    catch(error){
        
        if(error.response.status === 404){
            let receipt = undefined;
            let pdfString = "";
            yield put(receiptReducerActions.receiptFound({receipt, pdfString}));
        } else {

            logman.error(error);
            toast.error(error);
            
            if(error.response.status === 403){

                let status = error.response.status;
                let msg = "Forbidden. You do not have access to view this page.";

                yield put(uis.actions.error({ status, msg }));
                
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }

            // yield put(uis.actions.showNotification({
            //     status:"error",
            //     title:"Error",
            //     message: "There was an error with searching for the receipt."
            // }));

            yield put(receiptReducerActions.catchError({
                callType: receiptReducerCallTypes.searchingRcpt,
                error: "There was an error with searching for the receipt."
            }));
        }
    }
};

export function* onGetOTPCodeStartAsync({payload}){

    try{
        
        yield put(receiptReducerActions.startCall({ callType: receiptReducerCallTypes.action }));

        const response = yield call(getOtpCodeApi, payload.query);        

        if(response.status === 200){
            let successMsg = response.data;
            yield put(receiptReducerActions.otpSent({successMsg}));
        }
    }
    catch(error){
        logman.error(error);
        toast.error(error);

        let errorMsg = "There was an error with sending the OTP code.";

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: errorMsg
        // }));

        yield put(receiptReducerActions.catchError({
            callType: receiptReducerCallTypes.action,
            error: errorMsg
        }));
    }
};

export function* onValidateOTPCodeStartAsync({payload}){

    try{
        
        yield put(receiptReducerActions.startCall({ callType: receiptReducerCallTypes.validatingOTP }));

        const response = yield call(validateOtpApi, payload.query);        

        if(response.status === 200){
            let result = response.data.result;
            let rpctObj = {    
                receipt_number: response.data.receipt_number,
                cust_id: response.data.cust_id,
                cust_msisdn: response.data.cust_msisdn,
                pin: response.data.pin,
                dateTime: response.data.dateTime
            };
            yield put(receiptReducerActions.otpValidated({ result, rpctObj }));
        }
    }
    catch(error){
        logman.error(error);
        toast.error(error);

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error validating the OTP code."
        // }));

        yield put(receiptReducerActions.catchError({
            callType: receiptReducerCallTypes.validatingOTP,
            error: "There was an error validating the OTP code."
        }));
    }
};

export function* onGenerateReceiptReportStartAsync({payload}){

    try{
        
        yield put(receiptReducerActions.startCall({ callType: receiptReducerCallTypes.rcptReportStr }));

        const response = yield call(generateRcptReportApi, payload.receiptNumber);        

        if(response.status === 200){
            let res = response.data;
            yield put(receiptReducerActions.generatedReportStr({res}));
        }
    }
    catch(error){
        logman.error(error);
        toast.error(error);

        let errorMsg = "There was an error generating the PDF e-receipt.";

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: errorMsg
        // }));

        yield put(receiptReducerActions.catchError({
            callType: receiptReducerCallTypes.rcptReportStr,
            error: errorMsg
        }));
    }
};

export const actionTypes = {
    FindReceipt: "[FindReceipt] Find Receipt API Action",
    GetOTPCode: "[GetOTP] Get OTP Code API Action",
    ValidateOTP: "[ValidateOTP] Validate OTP API Action",
    GenerateReceiptReport: "[GenerateRcptRpt] Generate Jasper Receipt Report API Action"
};

export const actions = {

    findReceipt: (receiptNumber) => ({ type: actionTypes.FindReceipt, payload: { receiptNumber } }),
    getOtpCode: (query) => ({ type: actionTypes.GetOTPCode, payload: { query } }),
    validateOTP: (query) => ({ type: actionTypes.ValidateOTP, payload: { query } }),
    generateRcptReport: (receiptNumber) => ({ type: actionTypes.GenerateReceiptReport, payload: { receiptNumber } })

};

export function* findReceipt(){

    yield takeEvery(actionTypes.FindReceipt,onFindReceiptStartAsync);    
};

export function* getOtpCode(){

    yield takeEvery(actionTypes.GetOTPCode, onGetOTPCodeStartAsync);
};

export function* validateOTP(){

    yield takeEvery(actionTypes.ValidateOTP, onValidateOTPCodeStartAsync);
};

export function* generateRcptReport(){

    yield takeEvery(actionTypes.GenerateReceiptReport, onGenerateReceiptReportStartAsync);
};

const fSagas = [
    fork(findReceipt),
    fork(getOtpCode),
    fork(validateOTP),
    fork(generateRcptReport)
];

export function* saga(){
    yield all ([...fSagas]);
};